import { Avatar } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { SupporterComment } from '../../../../shared/types';

export function SupporterCommentCardHeader({
	supporterComment,
}: {
	supporterComment: SupporterComment;
}): React.JSX.Element {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<Flex sx={isSunriseThemeEnabled ? { gap: '8px' } : { gap: '10px' }}>
			<Avatar
				variant="subtle"
				src={supporterComment.user.photo?.userSmall.url}
				size={50}
				loading="lazy"
				alt={`Avatar of ${supporterComment.user.shortDisplayName}`}
			/>

			<Flex sx={{ flexDirection: 'column' }}>
				<Flex>
					<Text sx={{ fontWeight: '700' }}>{supporterComment.user.shortDisplayName}</Text>
					{supporterComment.user.city && <Text sx={{ fontWeight: '400' }}>{`, ${supporterComment.user.city}`}</Text>}
				</Flex>
				<Box>
					<Text color={isSunriseThemeEnabled ? 'sunrise.semantic.typography.strong' : 'typography-secondary'}>
						{supporterComment.createdAtRelativeLocalized}
					</Text>
				</Box>
			</Flex>
		</Flex>
	);
}
